import { render, staticRenderFns } from "./recorded-lecture.vue?vue&type=template&id=70226e32&scoped=true"
import script from "./recorded-lecture.vue?vue&type=script&lang=js"
export * from "./recorded-lecture.vue?vue&type=script&lang=js"
import style0 from "./recorded-lecture.vue?vue&type=style&index=0&id=70226e32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70226e32",
  null
  
)

export default component.exports